import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQIndex = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="index-sec-1 pricing-page-faq">
      <div className="container">
        <h2
          className="font--31 color-293F  fw--400"
          style={{ justifyContent: "center", textAlign: "center" }}
        >
          NxaTel Pricing FAQs
        </h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What is Nxatel and how does it help my business?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Nxatel is an all-in-one business communication platform that
                    integrates cloud calling, messaging, virtual meetings, and
                    storage to streamline operations and improve team
                    collaboration.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How long does it take to set up Nxatel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Getting started is easy! You can activate your Nxatel
                    account in just 3 minutes—no complicated setup, hardware, or
                    long contracts required.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do I need special hardware
                    {isMobile ? " " : <br />}
                    to use Nxatel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No, Nxatel works on any device—desktop, mobile, or tablet.
                    If you need desk phones, we support SIP-enabled devices like
                    Yealink and Poly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I keep my existing business number?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! You can port your current business number to Nxatel or
                    choose from local and international numbers in 25+
                    countries.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="number-of-boxIndex">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Is Nxatel secure and
                    {isMobile ? " " : <br />}
                    reliable?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Absolutely. We provide enterprise-grade security with
                    encrypted calls, secure messaging, and a 99.9% uptime
                    guarantee to ensure reliable communication.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What features are included
                    {isMobile ? " " : <br />} in Nxatel’s platform?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Nxatel includes cloud calling, video meetings, SMS, WhatsApp
                    Business integration, IVR (call menu), team messaging, and
                    cloud storage, all in one platform.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Question 7 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--white">7</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(7)}
                    aria-expanded={openQuestions[7]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I use Nxatel for remote work & team collaboration?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[7] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! Nxatel is designed for remote teams, allowing your
                    staff to stay connected anywhere through our mobile and
                    desktop apps.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 8 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--white">8</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(8)}
                    aria-expanded={openQuestions[8]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How much does Nxatel
                    {isMobile ? " " : <br />}
                    cost?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[8] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    We offer flexible pricing with no setup fees and no
                    long-term contracts. View our plans and pricing [here].
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 9 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">9</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(9)}
                    aria-expanded={openQuestions[9]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How do I get started
                    {isMobile ? "" : <br />}
                    with Nxatel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[9] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Simply sign up for a free trial or request a demo, and our
                    team will help you set up your account in minutes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQIndex;
